export default __webpack_public_path__ + "static/DSC_0148-4a26f732fff845d6f2773e0f7459e70f.jpg";